import { fetchAllInstances } from '@/requests/api/fetch-all-instances';
import type { Building } from '@pigello/pigello-matrix';
import { chunkIds } from '../utils';
import type { TCustomList } from './types';

interface WithBuilding {
  building?: { id: string } | Building | null;
}

export async function withBuildingRealEstate<T extends WithBuilding>(
  listResponse: TCustomList<T>
): Promise<TCustomList<T>> {
  const buildingIds = new Set<string>(
    listResponse.data
      .map((item) => item.building?.id)
      .filter((id): id is string => !!id)
  );

  if (buildingIds.size === 0) return listResponse;

  const buildingMap = new Map<string, Building>();
  const chunks = chunkIds(buildingIds);

  const results = await Promise.all(
    chunks.map((chunk) =>
      fetchAllInstances<Building>({
        modelName: 'building',
        filters: { id: { __in: chunk.join(',') } },
        nested: ['realestate'],
      })
    )
  );

  for (const res of results) {
    for (const building of res.list) {
      buildingMap.set(building.id, building);
    }
  }

  return {
    ...listResponse,
    data: listResponse.data.map((item) => {
      const buildingId = item.building?.id;
      if (!buildingId) return item;
      const fullBuilding = buildingMap.get(buildingId);
      if (!fullBuilding) return item;
      return { ...item, building: fullBuilding };
    }),
  };
}
